/*
 * @Descripttion: 
 * @version: 
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2020-09-08 16:25:52
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2020-09-11 17:45:32
 */

import Vue from 'vue'
import {wxAuthorization} from "@/api/api"
import {getUrlParams} from "@/js/utils"
import store from '@/store'
import { getCookie, setCookie } from '@/js/utils';


function delCodeandstate(to) { //函数作用：去除url中的code和state
    let path = ""
    for (let i in to.query) {
        if (i != "code" && i != "state") {
            path = path + "&" + i + "=" + to.query[i]
        }
    }
    path = path == "" ? "" : path.substring(1, path.length)
    path = path == "" ? "" : "/?" + path
    return path;
}
export const wxAuthLogin = (_self,callback) => {
    let fullPath = window.location.pathname+window.location.search;
    if (fullPath.includes("code")) { //判断url中是否有code，踩坑1-页面反复跳转
        fullPath = delCodeandstate(fullPath)
    }
    let redirect_uri = encodeURIComponent(process.env.URL + fullPath);
    // console.log(redirect_uri)
    let code =  window.location.search !='' ? getUrlParams(window.location.search.split("?")[1]).code: null,
        state = window.location.search !='' ? getUrlParams(window.location.search.split("?")[1]).state: null;
    // let code = '011ESDkl2vOqA54FOxol2bBJBl0ESDkH',
    // state = 'STATE';
    // console.log(code , state)
    if (code && state) { //登陆之后获取到code，传到后台登录
        wxAuthorization({ code: code },_self,{message: true}).then((res)=>{
            // console.log(res)
            if(res != 'false'){
                store.commit('SET_USER_ID', res.userId)
                setCookie("token",res.token,1 * 24 * 60 * 60 * 1000);
                if(callback) callback();
            }
        });
    } else { //未登录，没有token，去登录
        //去登录
        window.location.replace("https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + process.env.AppID + "&redirect_uri=" + redirect_uri + "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect");
    }
};


// WEBPACK FOOTER //
// ./src/js/auther.js